// extracted by mini-css-extract-plugin
export default {"empty":"BasketEmpty_empty__mSZn3","title":"BasketEmpty_title__IoIJL","text":"BasketEmpty_text__L7qEi","home":"BasketEmpty_home__R4NwS"};